import { BannerScope } from './banner-settings';

const PREFIX = 'cp-banner-dismissed';

export const bannerDismissKey = (params: {
    host?: string;
    scope: BannerScope;
    userId?: string | number;
    version: number;
}): string => {
    const host = params.host ?? 'unknown-host';
    const user =
        params.userId === undefined || params.userId === '' ? 'anon' : String(params.userId);
    return `${PREFIX}:${params.scope}:${host}:${user}:${params.version}`;
};

const keyPrefix = (scope: BannerScope, host?: string, userId?: string | number): string => {
    const hostPart = host ?? 'unknown-host';
    const user = userId === undefined || userId === '' ? 'anon' : String(userId);
    return `${PREFIX}:${scope}:${hostPart}:${user}:`;
};

export const isBannerDismissed = (key: string): boolean => {
    try {
        return sessionStorage.getItem(key) === '1';
    } catch {
        return false;
    }
};

export const dismissBanner = (params: {
    host?: string;
    scope: BannerScope;
    userId?: string | number;
    version: number;
}): void => {
    try {
        const prefix = keyPrefix(params.scope, params.host, params.userId);
        const toRemove: string[] = [];
        for (let i = 0; i < sessionStorage.length; i += 1) {
            const existing = sessionStorage.key(i);
            if (existing?.startsWith(prefix)) {
                toRemove.push(existing);
            }
        }
        toRemove.forEach(existing => sessionStorage.removeItem(existing));
        sessionStorage.setItem(bannerDismissKey(params), '1');
    } catch {
        // Safari private mode throws; fail open (caller still hides via local state).
    }
};
